module.exports = __webpack_public_path__ + "img/card1-bl4.a00b95b9.svg";